export default "__VITE_ASSET__P_Dt60ui__"